var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{ref:_vm.identifier,staticClass:"dj-media-svg",style:({
                '--svgSize':_vm.mediaSize,
             }),attrs:{"id":_vm.identifier,"aria-hidden":"true"}},[_c('use',{attrs:{"xlink:href":`#dj-svg-${_vm.media}`},on:{"click":_vm.click}})])
}
var staticRenderFns = []

export { render, staticRenderFns }